const model = {
    name: 'Ranking',
    properties: {
        name: { required: true },
        weight: {}, // TODO:  <float> >= 0.1
    },
};
export default model;
